import React from "react";
import classNames from "classnames";
import defaultPage from "../Page.module.scss";
import Navbar from "../../components/Navbar/Navbar";
import SearchBar from "../../components/SearchBar/SearchBar";
import styles from "./Dashboard.module.scss";
import { Outlet } from "react-router-dom";

const Dashboard = () => {
  return (
    <div
      className={classNames(
        defaultPage.page,
        "flex-lg-row",
        "flex-column",
        "justify-content-start",
        "align-items-start"
      )}
    >
      <Navbar />
      <div
        className={classNames(
          styles.content,
          "container-fluid",
          "d-flex",
          "flex-column",
          "justify-content-start",
          "align-items-start"
        )}
      >
        <SearchBar />
        <Outlet />
      </div>
    </div>
  );
};

export default Dashboard;
